<template>
    <div>
        <div class="button noselect"
             v-on:click="onclick()"
             :value="data"
        >

            <img v-if="typeof imgSrc !== 'undefined'" :src="imgSrc" alt="">
            <p class="btntext">{{btnTxt}}</p>
        </div>
        <input class="hidden" type="file" ref="fileselect" accept="video/*" :multiple="isMulti" @change="fileSelected">
    </div>
</template>

<script>
    export default {
        name: "BBtnSelectUpload",
        props: {
            imgSrc: String,
            btnTxt: String,
            isMulti: String,
            data: Object,
        },
        data() {
            return {
            }
        },
        methods: {
            onclick() {
                this.$refs.fileselect.value='';
                this.$refs.fileselect.click();
            },
            fileSelected() {
                let value = this.$refs.fileselect.value;
                let files = this.$refs.fileselect.files;
                this.$emit("input", {filepath: value, files: files});
            },
        }
    }
</script>

<style scoped>
    .button {
        height: 38px;
        background: #EDB903;
        border-radius: 5px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 14px;
    }

    .btntext {
        margin: 0 10px;
    }

    .button:hover {
        background: #ceb455;
    }

    .button:active {
        background: #af8d13;
    }

    .button img {
        width: 18px;
        height: 18px;
        margin-right: 5px;
    }

    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                         supported by Chrome and Opera */
    }

    .hidden {
        display: none;
    }
</style>